import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import MPHButton from "../MPHButtons/MPHButton";
import MPHCheckbox from "src/components/DataProviders/MPHCheckBox";
import { useApiAxiosRequests } from "src/utils/ApiService/MPHApis";
import { useStorage } from "src/utils/storage";
import { errorToast, successToast } from "src/utils/toast";
import moment from "moment";
import "./MPHOptIn.scss";

const MPHOptIn = ({isLogIn, acquisitionChannel}: any) => {
  const navigate = useNavigate();
  const { issuePromotion, promotionBE } = useApiAxiosRequests();
  const storage = useStorage();
  const [isLoading, setIsLoading] = useState(false);
  const [isChecked, setIsChecked] = useState('0');
  const REACT_APP_SWEEPSTAKES_PROMOTION_ID = process.env.REACT_APP_SWEEPSTAKES_PROMOTION_ID;
  const programId = process.env.REACT_APP_PROGRAM_ID;

  const handleOptIn = async () => {
    setIsLoading(true);
    const userProfile = await storage.get('user_profile') || '';
    const parsedData = JSON.parse(userProfile);
    const email = parsedData?.email;

    const body = {
      "programId": programId,
      "promotionId": REACT_APP_SWEEPSTAKES_PROMOTION_ID
    }

    const bePayload = {
      "customer_email": email,
      "entry_date": moment().format("YYYY-MM-DD"),
      "sweepstake_id": REACT_APP_SWEEPSTAKES_PROMOTION_ID,
      "event_name": "Opt_Tulum_Sweepstakes",
      "acquisition_channel": acquisitionChannel || "web",
    }

    try {
    const res: any = await issuePromotion(email, body);
    const resData = res?.data ?? res;
    const warnings = resData?.warnings || [];
    const errors = resData?.errors || [];
    const hasSideEffects =
      Array.isArray(resData?.sideEffects) && resData.sideEffects.length > 0;

    if (errors.length > 0) {
      const errorMessage =
        "Error occurred while processing your request. Please try again later.";
      errorToast(errorMessage);
      navigate("/find-hotels");
      return;
    }

    if (warnings.length > 0) {
      errorToast("You've already entered");
      navigate("/find-hotels");
      return;
    }

    if (hasSideEffects) {
      const beRes: any = await promotionBE(bePayload);
      setIsLoading(false);
      if (beRes?.data?.status?.code === 1100) {
        successToast("Success! You’re registered");
        navigate("/status");
      } else {
        errorToast("OptIn Failed");
      }

    } else {
      errorToast("Customer already opted in or is unable to opt in");
      navigate("/find-hotels");
    }
    } catch (error) {
      errorToast("An error occurred while processing your request. Please try again later.");
      console.error("Error during opt-in:", error);
    } finally {
      setIsLoading(false);
    }

  }

  return (
    <div className="ptp-optin">
      <div className="ptp-optin__card">
        <div className="ptp-optin__header">
          <span className="ptp-optin__tag">My Place Hotels · Stay Rewarded</span>
          <h2 className="ptp-optin__title">Take Me to Tulum</h2>
          <p className="ptp-optin__subtitle">Sweepstakes</p>
        </div>

        <div className="ptp-optin__body">
          <MPHCheckbox
            label={"Register me for the Take Me to Tulum Sweepstakes"}
            key={"email"}
            id={"email"}
            isModal={true}
            value={isChecked !== "0"}
            onChangeText={(text: any) => {
              text === true ? setIsChecked("1") : setIsChecked("0");
            }}
          />
        </div>

        <div className="ptp-optin__footer">
          <MPHButton
            buttonText="Submit"
            disabled={isLoading || isChecked === "0"}
            isLoading={isLoading}
            onbuttonClick={() => handleOptIn()}
          />
        </div>
      </div>
    </div>
  )

}

export default MPHOptIn